import { createApp } from 'utils/vue';
import App from "components/pages/usersettings/edit";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App).mount("#app-container");
};

registerHandler("usersettings/edit", handler);
